import { IAMUser } from '@sls-react/typings/services/iam/auth';
import sha1 from 'js-sha1';
import identifySentryUser from '@sls-react/services/sentry/identifyUser';
import getEnv from '@sls-react/utils/getEnv';
import { fetchV1Session } from '@sls-react/api/auth';
import fireGAEvent from '@sls-react/services/analytics/fireGAEvent';

export const trackingIdentifyAnonymous = () => {
  window.ire?.('identify', {
    customerId: '',
    customerEmail: '',
  });
};

export async function trackingIdentify(user: IAMUser) {
  if (!user) {
    return;
  }

  if (getEnv() !== 'production') {
    console.log('identifying user', user);
  }

  if (window.amplitude) {
    window.amplitude.getInstance().setUserId(user.external_id);
    window.amplitude
      .getInstance()
      .setUserProperties({ username: user.username });
  }

  if (window.ire) {
    window.ire?.('identify', {
      customerId: user.external_id,
      customerEmail: sha1(user.email),
    });
  }

  fireGAEvent('set', 'userId', user.external_id);

  if (window.hj) {
    try {
      const session = await fetchV1Session();
      window.hj('identify', user.external_id, {
        'Purchase Count': session.user.properties.purchase_count,
        'List Count': session.user.properties.list_count,
        'Sale Count': session.user.properties.sales_count,
        'Purchase Month': session.user.properties.purchase_mon,
        'Purchase Sport': session.user.properties.purchase_sport,
        'List Month': session.user.properties.list_mon,
        'Join Date': session.user.properties.join_date,
        Username: user.username,
      });
    } catch (e) {
      window.hj('identify', user.external_id, {
        Username: user.username,
      });
    }
  }

  window.Sentry?.setUser(identifySentryUser(user));
}

export const trackingUnidentify = () => {
  window.amplitude?.getInstance().clearUserProperties();
};
